import { Outlet } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { useSidebar } from "../Sidebar/SidebarContext";


export default function Main() {
    const { isDesktopCollapsed } = useSidebar();

    return (
        <>
            <Sidebar />
            <main>
                <div className={`w-full transition-all duration-300 ${isDesktopCollapsed ? 'lg:ps-20' : 'lg:ps-64'}`}>
                    <div className="">
                        <Header />
                            <Outlet />
                        <Footer />
                    </div>
                </div>
            </main>
        </>
    )
}